/* globals axios */

import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('ask-the-team-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            countryCode: '',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        EventBus.$on('document-ready-state', (state) => {
            if (state === 'complete') {
                this.loadScripts();
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        updateCountryCode(value) {
            this.countryCode = value;
        },

        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios
                .post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        this.scrollToFirstError();
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    window.location = this.$refs.redirectUrl.value;
                    // this.scrollToTop();
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error.response);
                });
        },

        loadScripts() {
            const formSetup = document.createElement('script');
            formSetup.setAttribute('type', 'application/javascript');
            formSetup.innerHTML = `
                var ss_form = { 'account': 'MzawMLE0MzczBgA', 'formID': 'M0yxsExLMU_VNTY0NNI1sUw20000MTHQNU9LNTVKNkhNSzFJBAA' };
                ss_form.width = '100%';
                ss_form.domain = 'app-3QNUW33EFM.marketingautomation.services';
                ss_form.hidden = {'_usePlaceholders': true};
                ss_form.target_id = 'ss-ask-the-team'; // Optional parameter: forms will be placed inside the element with the specified id
            `;

            document.body.appendChild(formSetup);

            const tag = document.createElement('script');
            tag.setAttribute('type', 'application/javascript');
            tag.setAttribute(
                'src',
                'https://koi-3QNUW33EFM.marketingautomation.services/client/form.js?ver=2.0.1',
            );

            document.body.appendChild(tag);
        },
    },
});
